import { PATH_PROJECTS, PATH_ROOT } from "@/constants";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";
import { generateDisplayName } from "@/modules/projects/lib/generateDisplayName";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { ReadProject } from "@/types/project";
import { UseQueryResult } from "@tanstack/react-query";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useProjectBreadcrumb = (
  query: UseQueryResult<ReadProject | null, Error>,
  additionalItems?: (BreadcrumbItem | undefined)[],
) => {
  const { t } = useTranslation();
  const projectId = useProjectId();

  return useMemo(() => {
    const breadcrumbItems: BreadcrumbItem[] = [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("projects.breadcrumb.projects"), href: PATH_PROJECTS },
    ];

    if (projectId) {
      breadcrumbItems.push({
        label: t("projects.breadcrumb.project", {
          name: query?.data ? generateDisplayName(query?.data) : "...",
        }),
        href: `${PATH_PROJECTS}/${projectId}`,
      });
    }

    if (additionalItems && additionalItems.length > 0) {
      breadcrumbItems.push(...additionalItems.filter((item) => !!item));
    }

    return breadcrumbItems;
  }, [t, projectId, query?.data, additionalItems]);
};
